import ZForm from '@/ZForms/parsers/forms/ZForm.js';
import ZField from './ZField.js';


class ZLinkFieldDefaultForm extends ZForm {
  constructor() {
    super(...arguments);
    this.isZLinkFieldDefaultForm = true;

    this.updateFromRaw({
      'content_meta': {
        'fields': {
          'entity_name': {'type': 'text'},
          'view': {'type': 'text'},
          'uid': {'type': 'text'},
        },
      },
    });
  }
}


class LinkType {
  constructor(rawData, basedField) {
    this.basedField = basedField;
    this.listFormUid = rawData.list_form_uid;
    this.type = rawData.type;
    this.view = rawData.view;
  }
}

export default window.ZForms.registerClass('field.link', class ZLinkField extends ZField {
  constructor() {
    super(...arguments);
    this.entityForm = null;
    this.linkTypes = [];
  }

  async _updateMetaFromRaw(rawData) {
    await super._updateMetaFromRaw(rawData);
    this.entityForm = rawData.entity_list_form == null ? this.entityForm : await window.ZForms.parseRaw(rawData.entity_list_form, null, this.rootEntity);
    this.entityForm = this.entityForm == null ? new ZLinkFieldDefaultForm() : this.entityForm;
    this.linkTypes = rawData.link_types == null ? this.linkTypes : rawData.link_types.map(
        (rawType) => new LinkType(rawType, this),
    );
  }

  async parseRawValue(rawVal) {
    if (rawVal == null) return null;
    return await window.ZForms.parseRaw(rawVal, this.entityForm.contentMeta, this.rootEntity);
  }

  getDefault() {
    return null;
  }

  packResponseValue(val) {
    if (val == null) return null;

    return val.packResponse();
  }
});
